// Generated by ReScript, PLEASE EDIT WITH CARE


var Js_ = {};

function fromJs(js) {
  switch (js) {
    case 1 :
        return /* Loading */0;
    case 2 :
        return /* SetVariables */1;
    case 3 :
        return /* FetchMore */2;
    case 4 :
        return /* Refetch */3;
    case 5 :
        return /* SkippedOrNotPresent */7;
    case 6 :
        return /* Poll */4;
    case 7 :
        return /* Ready */5;
    case 8 :
        return /* Error */6;
    default:
      return /* SkippedOrNotPresent */7;
  }
}

var NetworkStatus = {
  Js_: Js_,
  fromJs: fromJs
};

export {
  NetworkStatus ,
}
/* No side effect */
